(function () {
	'use strict';

	angular.module('mx.components').component('mxShellBackgroundProcesses', {
		controllerAs: 'vm',
		templateUrl: 'components/mx-shell-background-processes/mx-shell-background-processes.html',
		controller: MxBackgroundProcessesController,
	});

	MxBackgroundProcessesController.$inject = ['mx.shell.BackgroundProcessesService'];

	function MxBackgroundProcessesController(backgroundProcesses) {
		var vm = this;

		vm.$onInit = function () {
			vm.service = backgroundProcesses;
			vm.cancelProcess = cancelProcess;
		};

		async function cancelProcess(item) {
			await backgroundProcesses.cancelProcess(item);
		}

		return vm;
	}
})();
